import React from "react"
import { Box, Button, CircularProgress, Grid, Stack } from "@mui/material"
import { useSelector } from "react-redux"
import SingleArticle from "./SingleArticle"
import { useNavigate } from "react-router-dom"
import Advertisement from "../Advertisement"
import { AddCircleOutline } from "@mui/icons-material"

const AllArticles = () => {
  const navigate = useNavigate()
  const { posts, isLoading } = useSelector((state) => state.posts)

  return isLoading ? (
    <CircularProgress />
  ) : (
    <>
      <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
        <Button
          onClick={() => navigate("/posts/add")}
          startIcon={<AddCircleOutline />}
          variant="contained"
        >
          Add Post
        </Button>
      </Box>

      <Stack direction="row" spacing={2}>
        <Box flex={3}>
          <Grid container spacing={2}>
            {posts?.length > 0 &&
              posts?.map((post) => (
                <Grid key={post._id} item xs={12} sm={6} md={4} lg={3}>
                  <SingleArticle key={post._id} post={post} />
                </Grid>
              ))}
          </Grid>
          <Box sx={{ display: { sm: "block", md: "none" } }}>
            <Advertisement />
          </Box>
        </Box>
        <Box flex={1} sx={{ display: { xs: "none", md: "block" } }}>
          <Advertisement />
        </Box>
      </Stack>
    </>
  )
}
export default AllArticles
